<template>
  <div id="app" class="layout">
    <router-view v-if="isLoginRoute" />
    <el-container v-else class="layout-wrap">
      <div v-if="isMobile && asideOpen" class="mobile-aside-mask" @click="closeAside"></div>
      <el-aside
        :width="asideWidth"
        class="aside"
        :class="{
          'aside--hidden': !asideOpen && !isMobile,
          'aside--mobile': isMobile,
          'aside--mobile-open': isMobile && asideOpen,
        }"
      >
        <div class="logo">关务管理</div>
        <el-menu
          class="aside-menu app-sidebar-menu"
          :default-active="$route.path"
          router
          @select="onMenuSelect"
        >
          <el-menu-item v-if="canAnyPerm(['menu.dashboard', 'dashboard.read'])" index="/dashboard">
            <i class="el-icon-data-line"></i>
            <span>首页看板</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.containers', 'containers.read'])" index="/containers">
            <i class="el-icon-box"></i>
            <span>货柜管理</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.containers', 'containers.read'])" index="/containers/inspection">
            <i class="el-icon-view"></i>
            <span>查验货柜</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.containers', 'containers.read'])" index="/container-documents">
            <i class="el-icon-folder-opened"></i>
            <span>货柜单据</span>
          </el-menu-item>
          <el-submenu v-if="canAnyPerm(['menu.declarations.prerecord', 'menu.declarations.review', 'menu.declarations.publish', 'menu.declarations.formal', 'declarations.read'])" index="menu-declarations">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>报关管理</span>
            </template>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.prerecord', 'declarations.prerecord.read', 'declarations.read'])" index="/declarations/prerecord">预录报关单</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.review', 'declarations.review.read', 'declarations.read'])" index="/declarations/review">报关单审核</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.publish', 'declarations.publish.read', 'declarations.read'])" index="/declarations/publish-notify">报关单已通知</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.publish', 'declarations.publish.read', 'declarations.read'])" index="/declarations/publish">报关单待核对</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.publish', 'declarations.publish.read', 'declarations.read'])" index="/declarations/publish-confirm">报关单己核对</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.declarations.formal', 'declarations.formal.read', 'declarations.read'])" index="/declarations/formal">报关单已申报</el-menu-item>
          </el-submenu>
          <el-submenu v-if="canAnyPerm(['menu.cutoffs', 'cutoffs.read'])" index="menu-cutoffs">
            <template slot="title">
              <i class="el-icon-time"></i>
              <span>截单管理</span>
            </template>
            <el-menu-item index="/cutoffs">截单列表</el-menu-item>
            <el-menu-item index="/cutoffs/provider-profiles">服务商资料</el-menu-item>
          </el-submenu>
          <el-menu-item v-if="canAnyPerm(['menu.clearances', 'clearances.read'])" index="/clearances">
            <i class="el-icon-circle-check"></i>
            <span>清关管理</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.pickups', 'pickups.read'])" index="/pickups">
            <i class="el-icon-truck"></i>
            <span>提货管理</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.fees', 'fees.read'])" index="/fees">
            <i class="el-icon-money"></i>
            <span>费用中心</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.ports', 'ports.read'])" index="/ports">
            <i class="el-icon-location-outline"></i>
            <span>港口管理</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.providers', 'providers.read'])" index="/providers">
            <i class="el-icon-office-building"></i>
            <span>服务商管理</span>
          </el-menu-item>
          <el-menu-item v-if="canAnyPerm(['menu.customers', 'customers.read'])" index="/customers">
            <i class="el-icon-s-shop"></i>
            <span>客户管理</span>
          </el-menu-item>
          <el-submenu
            v-if="canAnyPerm(['menu.declaration_uploads', 'declaration_uploads.read'])"
            index="menu-declaration-uploads"
          >
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>上传管理</span>
            </template>
            <el-menu-item index="/declaration-uploads/batch">报关单批量上传</el-menu-item>
            <el-menu-item index="/declaration-uploads/links">关联数据</el-menu-item>
          </el-submenu>
          <el-submenu
            v-if="
              canAnyPerm(['menu.system.users', 'users.read']) ||
              canAnyPerm(['menu.system.roles', 'roles.read']) ||
              canAnyPerm(['menu.system.permissions', 'permissions.read']) ||
              canAnyPerm(['menu.system.mail_jobs', 'async_mail_jobs.read']) ||
              canAnyPerm(['menu.system.settings', 'settings.read'])
            "
            index="menu-system"
          >
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>系统管理</span>
            </template>
            <el-menu-item v-if="canAnyPerm(['menu.system.users', 'users.read'])" index="/system/users">用户管理</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.system.roles', 'roles.read'])" index="/system/roles">角色管理</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.system.permissions', 'permissions.read'])" index="/system/permissions">权限管理</el-menu-item>
            <el-menu-item
              v-if="canAnyPerm(['menu.system.mail_jobs', 'async_mail_jobs.read'])"
              index="/system/async-mail-jobs"
            >异步邮件任务</el-menu-item>
            <el-menu-item v-if="canAnyPerm(['menu.system.settings', 'settings.read'])" index="/system/settings">系统设置</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container class="layout-main-column">
        <el-header class="header">
          <div class="header-left">
            <el-button
              type="text"
              class="toggle-aside-btn"
              :title="asideOpen ? '收起侧栏' : '展开侧栏'"
              @click="toggleAside"
            >
              <i :class="asideOpen ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
            </el-button>
            <span class="title">{{ pageTitle }}</span>
          </div>
          <div class="header-right">
            <el-dropdown trigger="click" @command="onUserMenuCommand">
              <span class="user-menu-trigger">
                <i class="el-icon-user"></i>
                <span class="user-name">{{ displayUser }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="profile">个人信息</el-dropdown-item>
                <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <UserProfileDialog :visible.sync="profileDialogVisible" :user="currentUser" @saved="refreshCurrentUser" />

    <ForcedDisplayNameDialog :visible="needForceRealDisplayName" :user="currentUser" @saved="refreshCurrentUser" />
  </div>
</template>

<script>
import http from './api/http'
import { clearAuth, getStoredUser, getToken, onAuthChanged, setAuth } from './auth/session'
import UserProfileDialog from './components/UserProfileDialog.vue'
import ForcedDisplayNameDialog from './components/ForcedDisplayNameDialog.vue'
import { isValidChineseRealName } from './utils/chineseDisplayName'

const ASIDE_STORAGE_KEY = 'layout-aside-open'

export default {
  name: 'App',
  components: { UserProfileDialog, ForcedDisplayNameDialog },
  data() {
    return {
      /** 左侧菜单是否展开（false 时侧栏隐藏，主区域变宽） */
      asideOpen: true,
      /** 个人信息弹窗 */
      profileDialogVisible: false,
      /** 当前登录用户（响应式，用于右上角显示） */
      currentUser: null,
      unbindAuthChanged: null,
      /** 手机端判定（小屏时侧栏改为抽屉覆盖层） */
      isMobile: false,
      mediaQueryList: null,
      mediaChangeHandler: null,
    }
  },
  created() {
    try {
      const raw = sessionStorage.getItem(ASIDE_STORAGE_KEY)
      if (raw === '0') this.asideOpen = false
      if (raw === '1') this.asideOpen = true
    } catch (e) {
      /* 忽略 */
    }
    this.refreshCurrentUser()
    this.syncMePayload()
    this.unbindAuthChanged = onAuthChanged(this.refreshCurrentUser)
    this.bindMobileMedia()
  },
  beforeDestroy() {
    if (typeof this.unbindAuthChanged === 'function') {
      this.unbindAuthChanged()
      this.unbindAuthChanged = null
    }
    if (this.mediaQueryList && this.mediaChangeHandler) {
      if (this.mediaQueryList.removeEventListener) {
        this.mediaQueryList.removeEventListener('change', this.mediaChangeHandler)
      } else if (this.mediaQueryList.removeListener) {
        this.mediaQueryList.removeListener(this.mediaChangeHandler)
      }
    }
    this.mediaQueryList = null
    this.mediaChangeHandler = null
  },
  computed: {
    isLoginRoute() {
      const p = this.$route.path || ''
      if (p === '/login' || p.startsWith('/public/')) {
        return true
      }
      const m = this.$route.matched || []
      return m.some((r) => r.meta && r.meta.public)
    },
    displayUser() {
      const u = this.currentUser
      if (!u) return ''
      return (u.display_name || u.username || '').trim() || u.username || ''
    },
    pageTitle() {
      const metaTitle = this.$route.meta && this.$route.meta.pageTitle
      if (metaTitle) {
        return metaTitle
      }
      const map = {
        '/dashboard': '首页看板',
        '/containers': '货柜管理',
        '/containers/inspection': '查验货柜',
        '/containers/lcl-operations': '拼柜节点管理',
        '/container-documents': '货柜单据',
        '/cutoffs': '截单管理',
        '/cutoffs/provider-profiles': '截单服务商资料',
        '/clearances': '清关管理',
        '/pickups': '提货管理',
        '/fees': '费用中心',
        '/ports': '港口管理',
        '/providers': '服务商管理',
        '/customers': '客户管理',
        '/declaration-uploads/batch': '报关单批量上传',
        '/declaration-uploads/links': '关联数据',
        '/system/users': '用户管理',
        '/system/roles': '角色管理',
        '/system/permissions': '权限管理',
        '/system/settings': '系统设置',
      }
      return map[this.$route.path] || '海关关务管理系统'
    },
    asideWidth() {
      if (this.isMobile) return '220px'
      return this.asideOpen ? '220px' : '0px'
    },
    /**
     * 须先补全/修正为中文真实姓名（与后台 require_real_display_name 一致；并兼容旧 session 未拉 /me 前）
     */
    needForceRealDisplayName() {
      if (!this.currentUser || this.isLoginRoute) return false
      if (this.currentUser.require_real_display_name === true) return true
      const name = (this.currentUser.display_name || '').trim()
      if (!name) return true
      return !isValidChineseRealName(name)
    },
  },
  watch: {
    $route() {
      if (this.isMobile) {
        this.asideOpen = false
      }
    },
  },
  methods: {
    canAnyPerm(codes) {
      return Array.isArray(codes) && codes.some((c) => this.$hasPerm(c))
    },
    refreshCurrentUser() {
      this.currentUser = getStoredUser()
    },
    /** 拉取最新「当前用户」判断是否需要强制补全姓名（兼容旧 session 无 require 字段） */
    async syncMePayload() {
      if (this.isLoginRoute || !getToken()) return
      try {
        const res = await http.get('/me')
        setAuth({ token: getToken(), user: res.data })
        this.refreshCurrentUser()
      } catch (e) {
        /* 401 等由拦截器处理 */
      }
    },
    toggleAside() {
      this.asideOpen = !this.asideOpen
      try {
        sessionStorage.setItem(ASIDE_STORAGE_KEY, this.asideOpen ? '1' : '0')
      } catch (e) {
        /* 忽略 */
      }
    },
    closeAside() {
      this.asideOpen = false
    },
    onMenuSelect() {
      if (this.isMobile) {
        this.closeAside()
      }
    },
    onUserMenuCommand(cmd) {
      if (cmd === 'profile') {
        this.profileDialogVisible = true
        return
      }
      if (cmd === 'logout') {
        this.logout()
      }
    },
    bindMobileMedia() {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
      this.mediaQueryList = window.matchMedia('(max-width: 768px)')
      const apply = () => {
        const next = !!(this.mediaQueryList && this.mediaQueryList.matches)
        this.isMobile = next
        if (next) {
          // 手机端默认收起菜单，避免首屏被遮挡
          this.asideOpen = false
        }
      }
      this.mediaChangeHandler = apply
      if (this.mediaQueryList.addEventListener) {
        this.mediaQueryList.addEventListener('change', this.mediaChangeHandler)
      } else if (this.mediaQueryList.addListener) {
        this.mediaQueryList.addListener(this.mediaChangeHandler)
      }
      apply()
    },
    async logout() {
      try {
        await http.post('/auth/logout')
      } catch (e) {
        /* 忽略 */
      }
      clearAuth()
      this.$router.replace('/login')
    },
  },
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
/* 主布局占满视口，避免整页滚动导致侧栏与内容区同步滚动 */
#app.layout {
  min-height: 0;
}
.layout-wrap {
  height: 100vh;
  max-height: 100vh;
  min-height: 0;
  position: relative;
  overflow: hidden;
}
/* 右侧：顶栏固定高度，仅主内容区纵向滚动 */
.layout-main-column {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.layout-main-column > .el-header {
  flex-shrink: 0;
}
.layout-main-column > .el-main {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.aside {
  background: var(--app-navy-900);
  overflow: hidden;
  flex-shrink: 0;
  transition: width 0.22s ease;
  z-index: 1001;
  align-self: stretch;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}
.aside--hidden {
  border: none;
  min-width: 0 !important;
}
.mobile-aside-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
}
.logo {
  flex-shrink: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 20px 16px;
  text-align: center;
  border-bottom: 1px solid rgba(232, 117, 22, 0.22);
  background: linear-gradient(180deg, var(--app-navy-850) 0%, var(--app-navy-900) 100%);
  letter-spacing: 0.02em;
}
.aside-menu {
  border-right: none;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.header {
  background: #fff;
  box-shadow: var(--app-card-shadow);
  border-bottom: 1px solid rgba(7, 26, 47, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 60px;
  padding: 0 20px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.toggle-aside-btn {
  padding: 8px !important;
  font-size: 20px;
  color: #606266 !important;
}
.toggle-aside-btn:hover {
  color: var(--app-primary) !important;
}
.header .title {
  font-size: 16px;
  color: #303133;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  outline: none;
}
.user-menu-trigger:hover {
  color: var(--app-primary);
}
.user-name {
  font-size: 14px;
  color: #606266;
}
.main {
  background: var(--app-body-bg);
}
@media (max-width: 768px) {
  .aside--mobile {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 220px !important;
    max-width: 80vw;
    height: 100vh;
    max-height: 100vh;
    transform: translateX(-100%);
    transition: transform 0.22s ease;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.18);
  }
  .aside--mobile-open {
    transform: translateX(0);
  }
  .header {
    padding: 0 12px;
  }
  .header .title {
    font-size: 15px;
    max-width: 52vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-menu-trigger .user-name {
    display: none;
  }
  .main {
    padding: 8px;
  }
}
</style>
